"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const IMAGE_SRC =
	"/image/new-version/casting/High-Pressure-Die-Casting/high-pressure-die-casting-core-advantages.webp";

const ITEM_KEYS = [
	{ title: "hpdcCoreAdvantagesItem1Title", desc: "hpdcCoreAdvantagesItem1Desc" },
	{ title: "hpdcCoreAdvantagesItem2Title", desc: "hpdcCoreAdvantagesItem2Desc" },
	{ title: "hpdcCoreAdvantagesItem3Title", desc: "hpdcCoreAdvantagesItem3Desc" },
	{ title: "hpdcCoreAdvantagesItem4Title", desc: "hpdcCoreAdvantagesItem4Desc" },
	{ title: "hpdcCoreAdvantagesItem5Title", desc: "hpdcCoreAdvantagesItem5Desc" },
] as const;

const CheckIcon = () => (
	<svg
		className="h-3 w-3 sm:h-3.5 sm:w-3.5"
		viewBox="0 0 12 10"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			d="M1 5.2L4.6 8.8L11 1.2"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default function HighPressureCastingCoreAdvantages() {
	const t = useTranslations("new-high-pressure-casting");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 sm:mb-8 md:mb-10 lg:mb-12">
					<p className="mb-3 text-xs font-semibold uppercase tracking-[0.12em] text-themePrimary400 sm:text-sm">
						{t("hpdcCoreAdvantagesEyebrow")}
					</p>
					<h2 className="text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						{t("hpdcCoreAdvantagesTitle")}
					</h2>
					<p className="mt-3 text-sm leading-relaxed text-black sm:mt-4 md:text-base">
						{t("hpdcCoreAdvantagesDesc")}
					</p>
				</header>

				<div className="grid gap-8 lg:grid-cols-2 lg:items-start lg:gap-10 xl:gap-12">
					<div className="relative aspect-[4/3.8] w-full overflow-hidden bg-gray-100">
						<Image
							src={IMAGE_SRC}
							alt={t("hpdcCoreAdvantagesImageAlt")}
							fill
							className="object-cover"
							sizes="(max-width: 1024px) 100vw, 50vw"
							priority={false}
						/>
					</div>

					<ul className="flex list-none flex-col gap-6 sm:gap-7 md:gap-8">
						{ITEM_KEYS.map((item) => (
							<li key={item.title} className="flex gap-3 sm:gap-4">
								<span
									className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-themePrimary400 text-white"
									aria-hidden
								>
									<CheckIcon />
								</span>
								<div className="min-w-0">
									<h3 className="text-base font-semibold text-black sm:text-lg">{t(item.title)}</h3>
									<p className="mt-2 text-sm leading-relaxed text-black md:text-base">{t(item.desc)}</p>
								</div>
							</li>
						))}
					</ul>
				</div>
			</div>
		</section>
	);
}
